import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './footer.css';
import { useLanguage } from '../../context/LanguageContext';
import copy from '../../data/storefrontCopy.json';
import { getCategories } from '../Api/api';
import { getCategoryLandingPath, getCategoryNavigationPath } from '../../utils/catalogLanding';

const shopLinks = [
  ['Smartphones', '/collections/iphones-fes'],
  ['AirPods', '/collections/airpods-fes'],
  ['Chargeurs', '/collections/chargeurs-fes'],
  ['Powerbanks', '/collections/powerbanks-fes'],
  ['Montres connectées', '/collections/montres-connectees-fes'],
  ['Traceurs GPS', '/collections/gps-fes'],
];

const supportLinks = [
  ['Contact', '/contact-us'],
  ['Magasin a Fes', '/magasin-fes'],
  ['Livraison', '/livraison-maroc'],
  ['Garantie', '/about-us'],
  ['Retours', '/about-us'],
];

const trustItems = [
  ['fas fa-truck', 'Livraison rapide'],
  ['fas fa-shield-alt', 'Produits vérifiés'],
];

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { language } = useLanguage();
  const text = copy[language].footer;
  const [categories, setCategories] = useState([]);
  useEffect(() => {
    let cancelled = false;
    getCategories({ params: { include_counts: true } }).then(response => {
      if (!cancelled && Array.isArray(response.data)) setCategories(response.data);
    }).catch(() => { /* The main shop link remains usable if categories fail. */ });
    return () => { cancelled = true; };
  }, []);

  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-brand-column">
          <Link to="/" className="footer-logo" aria-label={text.homeLabel}>
            <img src="/images/mobiluxe_store.jpeg" alt="Mobiluxe Logo" />
          </Link>
          <p className="footer-brand-copy">
            {text.description}
          </p>

          <div className="footer-social">
            <a
              href="https://www.facebook.com/profile.php?id=61574516471476"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <i className="fab fa-facebook-f" />
            </a>
            <a
              href="https://www.instagram.com/mobiluxe_store/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <i className="fab fa-instagram" />
            </a>
            <a href="https://wa.me/212784814047" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
              <i className="fab fa-whatsapp" />
            </a>
            <a href="https://www.tiktok.com/@mobiluxe_store" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
              <i className="fab fa-tiktok" />
            </a>
          </div>
        </div>

        <div className="footer-links-column">
          <p className="footer-column-title">{text.shop}</p>
          <Link to="/shop">{language === 'ar' ? 'جميع المنتجات' : 'Tous les produits'}</Link>
          {shopLinks.map(([label, landingPath], index) => {
            const category = categories.find(item => getCategoryLandingPath(item) === landingPath);
            if (!category || (category.product_count != null && Number(category.product_count) === 0)) return null;
            return <Link key={label} to={getCategoryNavigationPath(category)}>{text.categories[index]}</Link>;
          })}
        </div>

        <div className="footer-links-column">
          <p className="footer-column-title">{text.support}</p>
          {supportLinks.map(([label, href], index) => (
            <Link key={label} to={href}>{text.supportLinks[index]}</Link>
          ))}
        </div>

        <div className="footer-contact">
          <p className="footer-column-title">{text.contact}</p>
          <p>
            <a href="mailto:mobiluxe95@gmail.com" dir="ltr">mobiluxe95@gmail.com</a>
          </p>
          <p>
            <a href="tel:+212784814047" dir="ltr">0784 81 40 47</a>
          </p>
          <p>{text.address}</p>
          <p>{text.hours}</p>
        </div>
      </div>

      <div className="footer-trust-row" aria-label={text.support}>
        {trustItems.map(([icon, label], index) => (
          <div key={label} className="footer-trust-item">
            <i className={icon} aria-hidden="true" />
            <span>{text.trust[index]}</span>
          </div>
        ))}
      </div>

      <div className="footer-signoff">
        <div className="footer-credit-link">
          <a
            className="footer-credit-name"
            href="https://www.instagram.com/abdellaoui.abderrahim"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram Abderrahim Abdellaoui"
          >
            {text.credit}
          </a>
          <a
            className="footer-credit-icon"
            href="https://www.instagram.com/abdellaoui.abderrahim"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram Abderrahim Abdellaoui"
          >
            <i className="fab fa-instagram" aria-hidden="true" />
          </a>
        </div>
        <p className="footer-copy">&copy; {currentYear} Mobiluxe Store. {text.rights}</p>
      </div>
    </footer>
  );
};

export default Footer;
